import { ImageComparisonBlockConfigSchema } from '@onefootprint/request-types/smart-block-schemas';
import type { ImageComparisonBlockConfig } from '@onefootprint/request-types/smart-blocks';
import { createParser } from '@/components/block-primitives/contracts/agent-blocks';

const parseConfig = createParser<ImageComparisonBlockConfig>(ImageComparisonBlockConfigSchema);
const parseImageComparisonBlockConfig = (raw: string): ImageComparisonBlockConfig | null => {
  const config = parseConfig(raw);
  if (!config) return null;
  if (
    config.images.some(image => {
      const suffix = image.documentIdentifier.slice(image.documentIdentifier.lastIndexOf(':') + 1);
      const version = Number(suffix);
      return !Number.isSafeInteger(version) || version < 0 || String(version) !== suffix;
    })
  )
    return null;
  const ids = new Set(config.images.map(image => image.id));
  if (ids.size !== config.images.length) return null;
  const { left, right } = config.initialSelection ?? {};
  if ((left != null && !ids.has(left)) || (right != null && !ids.has(right))) return null;
  if (left != null && left === right) return null;
  return config;
};

export { parseImageComparisonBlockConfig };
